import { PersonIcon } from '@radix-ui/react-icons';
import { cn } from '@/lib/utils';

export function GuestAvatar({
  size = 'sm',
  className,
  'data-name': dataName = 'GUEST_AVATAR',
}: {
  size?: 'sm' | 'md';
  className?: string;
  'data-name'?: string;
}) {
  return (
    <span
      data-name={dataName}
      className={cn(
        'inline-flex shrink-0 items-center justify-center rounded-full bg-muted text-muted-foreground',
        size === 'md' ? 'h-10 w-10' : 'h-5 w-5',
        className,
      )}
      aria-hidden="true"
    >
      <PersonIcon className={size === 'md' ? 'h-5 w-5' : 'h-3 w-3'} />
    </span>
  );
}
